export const environment = {
  production: true,
  url: 'https://api.mallgo.co',
  billsServiceUrl: 'https://8jqz5x05pd.execute-api.us-east-2.amazonaws.com/process',
  modelExecutorUrl: 'https://api.ai.inkremental.co/model-executor/requests',
  modelExecutorApiKey: 'uac_iM5j-1a6Q1bzdFTCL8HnI62PL10C-ZMJdRvznxq7FMw',
  recaptcha: {
    siteKey: '6Lc9bq0pAAAAAPFnHYDcktjY8QIAv4-uSxwvJlrV'
  },
};


export const SERVER_URL = 'https://api.demo.mallgo.co'
